module.exports = __webpack_public_path__ + "static/media/banner-ads-amazon.e77099f4.png";